import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { referencesApi } from '../../services/api';

/**
 * CDP + organizasyon referans verileri (dropdown kaynakları).
 *
 *   GET /rule-engine/segments     → [{ id, name, description, is_active }]
 *   GET /rule-engine/mudurlukler  → [{ code, user_count }]
 *
 * Bu listeler tenant-scoped ve nadir değişir; slice state'i cache gibi kullanılır
 * (ilk render'da yüklenir, sonraki formlar mevcut veriyi reuse eder).
 */

export const fetchSegments = createAsyncThunk(
  'references/segments',
  async (params = {}, { rejectWithValue }) => {
    try {
      const res = await referencesApi.segments(params);
      return res.data || [];
    } catch (err) {
      return rejectWithValue(err.message || 'Segmentler yüklenemedi');
    }
  },
);

export const fetchMudurlukler = createAsyncThunk(
  'references/mudurlukler',
  async (params = {}, { rejectWithValue }) => {
    try {
      const res = await referencesApi.mudurlukler(params);
      return res.data || [];
    } catch (err) {
      return rejectWithValue(err.message || 'Müdürlükler yüklenemedi');
    }
  },
);

const initialState = {
  segments: [],
  segmentsStatus: 'idle', // idle | loading | succeeded | failed
  segmentsError: null,
  mudurlukler: [],
  mudurluklerStatus: 'idle',
  mudurluklerError: null,
};

const referencesSlice = createSlice({
  name: 'references',
  initialState,
  reducers: {
    /** Cache invalidation — admin sonradan segment eklerse çağrılır. */
    invalidate(state) {
      state.segmentsStatus = 'idle';
      state.mudurluklerStatus = 'idle';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSegments.pending, (s) => {
        s.segmentsStatus = 'loading';
        s.segmentsError = null;
      })
      .addCase(fetchSegments.fulfilled, (s, a) => {
        s.segmentsStatus = 'succeeded';
        s.segments = a.payload;
      })
      .addCase(fetchSegments.rejected, (s, a) => {
        s.segmentsStatus = 'failed';
        s.segmentsError = a.payload;
      })
      .addCase(fetchMudurlukler.pending, (s) => {
        s.mudurluklerStatus = 'loading';
        s.mudurluklerError = null;
      })
      .addCase(fetchMudurlukler.fulfilled, (s, a) => {
        s.mudurluklerStatus = 'succeeded';
        s.mudurlukler = a.payload;
      })
      .addCase(fetchMudurlukler.rejected, (s, a) => {
        s.mudurluklerStatus = 'failed';
        s.mudurluklerError = a.payload;
      });
  },
});

export const { invalidate } = referencesSlice.actions;
export default referencesSlice.reducer;
